import { render } from "./JavaDocSearchPage.vue?vue&type=template&id=10b7f07e"
import script from "./JavaDocSearchPage.vue?vue&type=script&lang=js"
export * from "./JavaDocSearchPage.vue?vue&type=script&lang=js"

import "./JavaDocSearchPage.vue?vue&type=style&index=0&id=10b7f07e&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__